import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import productBgMainCircle from "../images/main-bg-circle.png";
import productBottomCircle from "../images/bottom-circles.png";
import productTopCircle from "../images/top-circles.png";
import "../styles/Products.css";
import translations from "./translations";
import { useLanguage } from "./Context/LanguageContext";

function Products() {
  const [productsList, setProductsList] = useState([]);
  const { language } = useLanguage();

  useEffect(() => {
    getProductList();
  }, []);

  async function getProductList() {
    try {
      const response = await fetch(
        "https://cairomed-backend.vercel.app/api/products/getProduct"
      );
      if (!response.ok) {
        throw new Error("Failed to fetch Products data");
      }
      const filteredData = await response.json();
      setProductsList(filteredData);
      console.log(filteredData);
    } catch (error) {
      console.error("Error fetching Products:", error);
    }
  }

  return (
    <main id="products">
      <section className="page-header">
          <div className="container">
            <div>
              <h1>{translations[language].heroSectionTitle}</h1>
              <h2>{translations[language].productsHeaderTitle}</h2>
              <p>
                {translations[language].productsHeaderParagraph}
              </p>
              <p>
                {translations[language].productsHeaderParagraph2}
              </p>
            </div>
          </div>
      </section>

      <section className="Products-section">
        <div className="container mt-3">
          {productsList?.length > 0 ? (
            productsList.map((product) => {
              return (
                <div className="whole-product-card" key={product._id}>
                  <div className="product-card">
                    <img src={productBgMainCircle} alt="" />
                    <img 
                      className="main-product-img" 
                      src={product.Image || "fallback-image.jpg"} 
                      alt={product.ProductName} 
                    />
                    <img className="product-top-circle" src={productTopCircle} alt="" />
                    <img className="product-bottom-circle" src={productBottomCircle} alt="" />
                  </div>
                  <h3 className="text-center mt-2">{language === 'en' ? product.ProductNameEN: product.ProductNameAR || "N/A"}</h3>
                  <Link className="type-1-btn" to={`SingleProduct/${product._id}`}>
                    <span>{translations[language].readMoreBTN}</span>
                    <i className="fa-solid fa-arrow-right"></i>
                  </Link>
                </div>
              );
            })
          ) : (
            
              <div className="loading-container ">
                <div className="loading-spinner"></div>
              </div>
            
          )}
        </div>
      </section>
    </main>
  );
}

export default Products;
